(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-admin"]) return;
  try {
    
(async function() {

    if ( !document.body.classList.contains('template-suffix-admin') ) return;
    document.body.classList.add(':loading');

    // dom ready
    await new Promise((resolve) => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", resolve);
        } else {
            resolve();
        }
    });

    // ref elems
    var grid = document.querySelector('#ecuqmbyghd .collection-grid__wrapper>.grid');
    var next = document.querySelector('#ecuqmbyghd .pagination .next>a');
    document.querySelector('#ecuqmbyghd .pagination').remove();

    while (next) {

        console.log(`LOADING: ${next.href}`);
        // do ajax
        next = await fetch(next.href)
        .then(response => response.text())
        .then(data => {
            // parse str as html
            const nextPage = new DOMParser().parseFromString(data, 'text/html');

            // append to grid
            grid.append(...nextPage.querySelectorAll('#ecuqmbyghd .collection-grid__wrapper>.grid .grid__item'));

            // is there next-next page?
            return nextPage.querySelector('#ecuqmbyghd .pagination .next>a');
        });

    }

    let data = [...document.querySelectorAll('#ecuqmbyghd .collection-grid__wrapper>.grid .grid__item')]
        .reduce((a,c)=>{
            let g = c.querySelector('.grid-product__title').innerHTML;
            if (!a[g]) a[g] = [];
            a[g].push({
                variant: c.querySelector('.grid-product__vendor').innerHTML,
                html: c.outerHTML
            });
            return a;
        }, {});

    data = Object.fromEntries(
        Object.keys(data)
        .sort()
        .map(key => {
            let x = 'variant';
            let val = data[key].sort((a, b) => ( a[x] < b[x] ? -1 : a[x] > b[x] ? 1 : 0 ));
            return [ key, val ];
        })
    );
    //console.log(data);

    window.data = data;
    window.page_html = document.body.innerHTML;
    // Restore with: document.body.innerHTML = window.page_html;

    let output = [];
    for (const item in data) {
      output.push(`${Object.values(data[item])[0].html}`);
    }
    //console.log(output.join(""));
    document.querySelector('#ecuqmbyghd .collection-grid__wrapper>.grid').innerHTML = output.join("");

    console.log('LOAD ALL PRODUCTS - COMPLETE');
    document.body.classList.remove(':loading');
    theme.headerNav.init();
    
    return;

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-hs_codes"]) return;
  try {
    
(async function() {

    //if ( !document.body.classList.contains('template-suffix-swatches') ) return;
    document.body.classList.add(':loading');

    // dom ready
    await new Promise((resolve) => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", resolve);
        } else {
            resolve();
        }
    });

    // ref elems
    var grid = document.querySelector('#wnaukewgnf .product-grid');
    var next = document.querySelector('#wnaukewgnf .pagination .next>a');
    document.querySelector('#wnaukewgnf .pagination').remove();

    while (next) {

        console.log(`LOADING: ${next.href}`);
        // do ajax
        next = await fetch(next.href)
        .then(response => response.text())
        .then(data => {
            // parse str as html
            const nextPage = new DOMParser().parseFromString(data, 'text/html');

            // append to grid
            grid.append(...nextPage.querySelectorAll('#wnaukewgnf .product-grid .product-block'));

            // is there next-next page?
            return nextPage.querySelector('#wnaukewgnf .pagination .next>a');
        });

    }

    let data = [...document.querySelectorAll('#wnaukewgnf .product-grid .product-block')]
        .reduce((a,c)=>{
            let g = c.dataset.group;
            if (!a[g]) a[g] = [];
            a[g].push({
                //id: c.dataset.id,
                url: c.dataset.handle,
            });
            return a;
        }, {});
        
    data = Object.fromEntries(
        Object.keys(data)
        .filter(key => (data[key].length > 1))
        .sort()
        .map(key => {
            let x = 'url';
            let val = data[key].sort((a, b) => ( a[x] < b[x] ? -1 : a[x] > b[x] ? 1 : 0 ));
            return [ key, val ];
        })
    );
    //console.log(data);

    window.data = data;
    window.page_html = document.body.innerHTML;
    // Restore with: document.body.innerHTML = window.page_html;
    //document.body.innerHTML = `<textarea readonly id="wnaukewgnf_jsondata">${JSON.stringify(data)}</textarea>`;

    console.log('LOAD ALL PRODUCTS - COMPLETE');
    document.body.classList.remove(':loading');
    //wnaukewgnf_jsondata.select();

    let empty_hs = [];
    let empty_hs_html = "<p><b>Empty HS codes:</b></p>";
    for (const item in data) {
        for (const variant in data[item]) {
            if (`${Object.values(data[item])[variant].swatch}` == "") {
                empty_hs.push(`${Object.values(data[item])[variant].url}`);
                empty_hs_html = empty_hs_html.concat('<a href="/products/',`${Object.values(data[item])[variant].url}`,'">https://rupertsanderson.com/products/',`${Object.values(data[item])[variant].url}`,'</a><br>');
            }
        }
    }
    //console.log(empty_hs);

    window.empty_hs = empty_hs;
    let empty_hs_div = document.createElement("div");
    empty_hs_div.innerHTML = empty_hs_html;
    document.body.append(empty_hs_div);

    return;

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-password-protected"]) return;
  try {
    
  jQuery(function(){
    jQuery('#protected-content-input').on('focus', function(e){
        jQuery('#protected-content-error').html('');
    });
    jQuery('#protected-content-form').on('submit', function(e){
      if( jQuery('#protected-content-input').val() == jQuery('#protected-content-password').val() ){
        jQuery('#protected-content-error').html('');
        jQuery('#protected-content-form-wrapper').hide();
        jQuery('#protected-content').show();
      }else{
        jQuery('#protected-content-error').html('<p style="color:red;">Incorrect password. Try again.</p>');
      }
      return false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-productlist"]) return;
  try {
    
(async function() {

    if ( !document.body.classList.contains('template-suffix-productlist') ) return;
    document.body.classList.add(':loading');

    // dom ready
    await new Promise((resolve) => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", resolve);
        } else {
            resolve();
        }
    });

    // ref elems
    var grid = document.querySelector('#whuerbjwez .collection-grid__wrapper>.grid');
    var next = document.querySelector('#whuerbjwez .pagination .next>a');
    document.querySelector('#whuerbjwez .pagination').remove();

    while (next) {

        console.log(`LOADING: ${next.href}`);
        // do ajax
        next = await fetch(next.href)
        .then(response => response.text())
        .then(data => {
            // parse str as html
            const nextPage = new DOMParser().parseFromString(data, 'text/html');

            // append to grid
            grid.append(...nextPage.querySelectorAll('#whuerbjwez .collection-grid__wrapper>.grid .grid__item'));

            // is there next-next page?
            return nextPage.querySelector('#whuerbjwez .pagination .next>a');
        });

    }

    let data = [...document.querySelectorAll('#whuerbjwez .collection-grid__wrapper>.grid .grid__item')]
        .reduce((a,c)=>{
            let g = c.querySelector('.grid-product__title').innerHTML + c.querySelector('.grid-product__vendor').innerHTML;
            if (!a[g]) a[g] = [];
            a[g].push({
                variant: c.querySelector('.grid-product__vendor').innerHTML,
                html: c.outerHTML
            });
            return a;
        }, {});

    data = Object.fromEntries(
        Object.keys(data)
        .sort()
        .map(key => {
            let x = 'variant';
            let val = data[key].sort((a, b) => ( a[x] < b[x] ? -1 : a[x] > b[x] ? 1 : 0 ));
            return [ key, val ];
        })
    );
    //console.log(data);

    window.data = data;
    window.page_html = document.body.innerHTML;
    // Restore with: document.body.innerHTML = window.page_html;

    let output = [];
    for (const item in data) {
      output.push(`${Object.values(data[item])[0].html}`);
    }
    //console.log(output.join(""));
    document.querySelector('#whuerbjwez .collection-grid__wrapper>.grid').innerHTML = output.join("");

    console.log('LOAD ALL PRODUCTS - COMPLETE');
    document.body.classList.remove(':loading');
    theme.headerNav.init();
    
    return;

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-swatches"]) return;
  try {
    
(async function() {

    if ( !document.body.classList.contains('template-suffix-swatches') ) return;
    document.body.classList.add(':loading');

    // dom ready
    await new Promise((resolve) => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", resolve);
        } else {
            resolve();
        }
    });

    // ref elems
    var grid = document.querySelector('#kefidbtqjc .product-grid');
    var next = document.querySelector('#kefidbtqjc .pagination .next>a');
    document.querySelector('#kefidbtqjc .pagination').remove();

    while (next) {

        console.log(`LOADING: ${next.href}`);
        // do ajax
        next = await fetch(next.href)
        .then(response => response.text())
        .then(data => {
            // parse str as html
            const nextPage = new DOMParser().parseFromString(data, 'text/html');

            // append to grid
            grid.append(...nextPage.querySelectorAll('#kefidbtqjc .product-grid .product-block'));

            // is there next-next page?
            return nextPage.querySelector('#kefidbtqjc .pagination .next>a');
        });

    }

    let data = [...document.querySelectorAll('#kefidbtqjc .product-grid .product-block')]
        .reduce((a,c)=>{
            let g = c.dataset.group;
            if (!a[g]) a[g] = [];
            a[g].push({
                //id: c.dataset.id,
                url: c.dataset.handle,
                img: new URL(c.querySelector('.image img').src).pathname.split("/").pop(),
                variant: c.querySelector('.variant').innerHTML,
                swatch: (c.querySelector('.swatch img') ? new URL(c.querySelector('.swatch img').src).pathname.split("/").pop() : "")
            });
            return a;
        }, {});
        
    data = Object.fromEntries(
        Object.keys(data)
        .filter(key => (data[key].length > 1))
        .sort()
        .map(key => {
            let x = 'variant';
            let val = data[key].sort((a, b) => ( a[x] < b[x] ? -1 : a[x] > b[x] ? 1 : 0 ));
            return [ key, val ];
        })
        //.reduce((res, key) => (res[key] = data[key], delete res[key].id, res), {})
    );
    //console.log(data);

    window.data = data;
    window.page_html = document.body.innerHTML;
    // Restore with: document.body.innerHTML = window.page_html;
    document.body.innerHTML = `<textarea readonly id="kefidbtqjc_jsondata">${JSON.stringify(data)}</textarea>`;

    console.log('LOAD ALL PRODUCTS - COMPLETE');
    document.body.classList.remove(':loading');
    kefidbtqjc_jsondata.select();

    let empty_swatches = [];
    let empty_swatches_html = "<p><b>Empty swatches:</b></p>";
    for (const item in data) {
        for (const variant in data[item]) {
            if (`${Object.values(data[item])[variant].swatch}` == "") {
                empty_swatches.push(`${Object.values(data[item])[variant].url}`);
                empty_swatches_html = empty_swatches_html.concat('<a href="/products/',`${Object.values(data[item])[variant].url}`,'">https://rupertsanderson.com/products/',`${Object.values(data[item])[variant].url}`,'</a><br>');
            }
        }
    }
    //console.log(empty_swatches);

    window.empty_swatches = empty_swatches;
    let empty_swatches_div = document.createElement("div");
    empty_swatches_div.innerHTML = empty_swatches_html;
    document.body.append(empty_swatches_div);

    return;

})();

  } catch(e) { console.error(e); }
})();
})();
